import React, { createContext, useContext, useState, useEffect, useCallback, useRef } from 'react';
import { AppConfigService, CONFIG_DEFAULTS } from '../utils/appConfigService';

const AppConfigContext = createContext({
  config: CONFIG_DEFAULTS,
  loading: true,
  getConfig: (key) => CONFIG_DEFAULTS[key],
  refreshConfig: () => {},
});

export const useAppConfig = () => useContext(AppConfigContext);

export const AppConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(CONFIG_DEFAULTS);
  const [loading, setLoading] = useState(true);
  const mountedRef = useRef(true);

  const fetchConfig = useCallback(async () => {
    try {
      const all = await AppConfigService.getAll();
      if (mountedRef.current) {
        setConfig(all);
      }
    } catch (err) {
      console.error('AppConfigProvider fetch error:', err);
    } finally {
      if (mountedRef.current) setLoading(false);
    }
  }, []);

  useEffect(() => {
    mountedRef.current = true;
    fetchConfig();
    return () => { mountedRef.current = false; };
  }, [fetchConfig]);

  const getConfig = useCallback(
    (key) => config[key] ?? CONFIG_DEFAULTS[key] ?? null,
    [config],
  );

  const value = { config, loading, getConfig, refreshConfig: fetchConfig };

  return (
    <AppConfigContext.Provider value={value}>
      {children}
    </AppConfigContext.Provider>
  );
};
